import { Component, OnInit, Input, EventEmitter, Output } from '@angular/core';
import { CustomIconService } from 'src/app/core/services/custom-icon.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-layout-menu-item',
  templateUrl: './menu-item.component.html',
  styleUrls: ['./menu-item.component.scss']
})
export class LayoutMenuItemComponent implements OnInit {

  @Input() icon: string;
  @Input() title: string;
  @Input() new: string;
  @Input() url: string;
  @Input() class: string;
  @Input() key: string;

  @Output() verify = new EventEmitter();

  constructor(
    private customIconService: CustomIconService,
    public router: Router
  ) { }

  ngOnInit() {
    this.customIconService.init();
  }

  verifyMenu() {
    this.verify.emit();;
  }
}
